// src/context/DocumentContext.js

import React, { createContext, useState } from 'react'

export const DocumentContext = createContext();

export const DocumentProvider = ({ children }) => {

    // Holds the JSON object for the selected document.
    const [selectedDocument, setSelectedDocument] = useState(null);
    // Holds the filename of the selected document.
    const [documentFilename, setDocumentFilename] = useState('');

    return (
        <DocumentContext.Provider
            value={{ selectedDocument, setSelectedDocument, documentFilename, setDocumentFilename }}
        >
            {children}
        </DocumentContext.Provider>
    )
}